import * as React from 'react';
import { app, dialog } from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router-dom';
import { initializeIcons, Icon } from '@fluentui/react';
import { Button, Checkbox, Input, Dropdown, Image, Text, Flex, FlexItem, List, Menu, Tooltip, TextArea } from '@fluentui/react-northstar';
import { AddIcon, CloseIcon, CalendarIcon, ExclamationCircleIcon, InfoIcon, ShieldKeyholeIcon, HeadsetIcon, BuildingIcon, TranslationIcon } from '@fluentui/react-icons-northstar';
import { getUserGroups, setAppSettings, getAppSettings, searchGroups, getGroups, getVersion, getAdmins, getAppCatalogId } from '../../api/settings-api';
import { getAppSetup, getAppConfig } from '../../api/teamsapp-api';
import { CommonHelper } from '../../helpers/common-helper';
import { ImageUtil } from '../../helpers/avatar-helper';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { LoaderConfigApp } from "../loaders/loaders";
import { updateLocale } from '../../i18n';
import Constants from '../../constants/data';
import Flags from '../../constants/flags';
import PesquisaSatisfacaoConstants from '../../constants/pesquisa-satisfacao';
import Features from '../../constants/features';
import ImagesBase64 from "../../constants/images-base64";
import './settings.scss';
const _ = require('lodash');

export interface SettingsState {
    groups: any[],
    selectedGestores: dropdownItem[],
    selectedGestoresId: string;
    selectedAtendentes: dropdownItem[],
    selectedAtendentesId: string;
    selectedGroupsNum: number,
    noResultMessage: string,
    loading: boolean,
    loader?: boolean,
    horarioAtendimentoInicial?: string,
    horarioAtendimentoFinal?: string,
    diasAtendimento?: any[],
    pesquisaSatisfacao?: string,
    urlPesquisaSatisfacaoExterna?: string,
    tipoCategoria?: string,
    ajudaComoFunciona?: string,
    isValidUrlAjudaComoFunciona?: boolean,
    ajudaPerguntasFrequentes?: string,
    isValidUrlAjudaPerguntasFrequentes?: boolean,
    isValidUrlPesquisaExterna?: boolean,
    listTiposCategorias: string[],
    isValidHorarioInicial?: boolean,
    isValidHorarioFinal?: boolean,
    isValidHorario?: boolean,
    appConfig: any;
    itemsPesquisaSatisfacao: string[],
    setup: boolean | null,
    selectedMenu: number,
    language: string,
    flagImage: string,
    version: string,
    admins: string[],
    recording: boolean,
    sharePointSiteUrl: string,
    isValidSharePointSiteUrl: boolean,
    features: string[],
    userQueueAttachments: boolean,
    welcomeText: string,
    appCatalogId: string,
}

export interface IListItem {
    header: string,
    media: any,
}

type dropdownItem = {
    key: string,
    header: string,
    content: string,
    image: string,
    team: {
        id: string,
    },
}

export type SettingsProps = {} & RouteComponentProps & WithTranslation;

class Settings extends React.Component<SettingsProps, SettingsState> {
    private localize: TFunction;
    flagPT: string;
    flagEN: string;
    flagES: string;
    appManifestId: string;
    searchParam?: any = null;

    constructor(props: SettingsProps) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            groups: [],
            selectedGestores: [],
            selectedGestoresId: "",
            selectedAtendentes: [],
            selectedAtendentesId: "",
            selectedGroupsNum: 0,
            noResultMessage: "",
            loading: false,
            loader: true,
            horarioAtendimentoInicial: "",
            horarioAtendimentoFinal: "",
            diasAtendimento: [],
            pesquisaSatisfacao: "",
            urlPesquisaSatisfacaoExterna: "",
            tipoCategoria: "",
            ajudaComoFunciona: "",
            isValidUrlAjudaComoFunciona: true,
            ajudaPerguntasFrequentes: "",
            isValidUrlAjudaPerguntasFrequentes: true,
            isValidUrlPesquisaExterna: true,
            listTiposCategorias: [],
            isValidHorarioInicial: true,
            isValidHorarioFinal: true,
            isValidHorario: true,
            appConfig: null,
            itemsPesquisaSatisfacao: [],
            setup: null,
            selectedMenu: 0,
            language: "",
            flagImage: "",
            version: "",
            admins: [],
            recording: false,
            sharePointSiteUrl: "",
            isValidSharePointSiteUrl: true,
            features: [],
            userQueueAttachments: false,
            welcomeText: null,
            appCatalogId: "",
        }

        this.flagPT = Flags.flagPT;
        this.flagEN = Flags.flagEN;
        this.flagES = Flags.flagES;
        this.searchParam = new URLSearchParams(window.location.search);
    }

    public async componentDidMount() {
        const params = this.props.match.params;

        if ('appId' in params) {
            const appId = (this.props.match.params as any).appId;
            this.appManifestId = appId
        }

        this.setupApp();
        this.getAppConfig();
        this.getAdmins();
        this.getVersion();
        this.getAppCatalogId();


        if ('id' in params) {
            let id = (this.props.match.params as any).id;

            this.getGroupData().then((graphData: any) => {
                const selectedGroups = this.makeDropdownItems(this.state.groups);

                getAppSettings().then((settingsData: any) => {
                    if (settingsData.data) {

                        const diasAtendimento: any[] = [];

                        if (settingsData.data.horarioAtendimentoDias && settingsData.data.horarioAtendimentoDias.length > 0) {
                            const diasAtendimentoStr = settingsData.data.horarioAtendimentoDias.split(',');

                            diasAtendimentoStr.forEach((item: any) => {
                                this.getDaysOfWeek().filter((day: any) => {
                                    if (item.trim() == day.key) {
                                        diasAtendimento.push(day);
                                    }
                                })
                            })
                        }

                        this.setState({
                            selectedGestores: settingsData.data ? selectedGroups.filter((g: any) => g.key == settingsData.data.gestores) : graphData.data,
                            selectedGestoresId: settingsData.data.gestores,
                            selectedAtendentes: settingsData.data ? selectedGroups.filter((g: any) => g.key == settingsData.data.atendentes) : graphData.data,
                            selectedAtendentesId: settingsData.data.atendentes,
                            diasAtendimento: diasAtendimento,
                            horarioAtendimentoInicial: settingsData.data.horarioAtendimentoInicial,
                            horarioAtendimentoFinal: settingsData.data.horarioAtendimentoFinal,
                            ajudaComoFunciona: settingsData.data.ajudaComoFunciona,
                            ajudaPerguntasFrequentes: settingsData.data.ajudaPerguntasFrequentes,
                            pesquisaSatisfacao: this.getPesquisaLocale(settingsData.data.pesquisaSatisfacao),
                            urlPesquisaSatisfacaoExterna: settingsData.data.urlPesquisaSatisfacaoExterna,
                            listTiposCategorias: settingsData.data.tiposCategorias,
                            language: settingsData.data.language,
                            recording: settingsData.data.autoRecordingGovernance,
                            sharePointSiteUrl: settingsData.data.sharePointSiteUrl,
                            loader: false,
                            features: settingsData.data.featuresList,
                            userQueueAttachments: settingsData.data.userQueueAttachments,
                            welcomeText: settingsData.data.welcomeText,
                        })

                        if (settingsData.data.language)
                            updateLocale(settingsData.data.language);

                        if (settingsData.data.language == "pt-BR")
                            this.setState({ flagImage: this.flagPT })
                        else if (settingsData.data.language == "en-US")
                            this.setState({ flagImage: this.flagEN })
                        else if (settingsData.data.language == "es-ES")
                            this.setState({ flagImage: this.flagES })
                    } else {
                        this.setState({
                            loader: false,
                        })
                    }
                })
            })
        }
    }

    /**
     * Parse week days locale
     * */
    public getDaysOfWeek = () => {
        return [
            { "header": this.localize("SegundaFeira"), "key": "segunda-feira" },
            { "header": this.localize("TercaFeira"), "key": "terça-feira" },
            { "header": this.localize("QuartaFeira"), "key": "quarta-feira" },
            { "header": this.localize("QuintaFeira"), "key": "quinta-feira" },
            { "header": this.localize("SextaFeira"), "key": "sexta-feira" },
            { "header": this.localize("Sabado"), "key": "sábado" },
            { "header": this.localize("Domingo"), "key": "domingo" }
        ];
    }

    /**
     * Pesquisa satusfação locale
     * */
    public getPesquisaLocale = (pesquisa?: string) => {
        if (pesquisa == "Nenhuma")
            return this.localize("Nenhuma")
        else if (pesquisa == "Classificação de atendimento")
            return this.localize("Classificacao")
        else if (pesquisa == "Pesquisa externa")
            return this.localize("PesquisaExterna")
        else if (pesquisa == "Pesquisa customizada")
            return this.localize("PesquisaCustomizada")
    }

    /**
     * Pesquisa satusfação labels locale
     * */
    public parsePesquisaLocale = (pesquisas: any) => {
        if (pesquisas) {
            return pesquisas.map((pesquisa: any) =>
                pesquisa.replace(/Nenhuma/, this.localize("Nenhuma"))
                    .replace(/Classificação de atendimento/, this.localize("Classificacao"))
                    .replace(/Pesquisa externa/, this.localize("PesquisaExterna"))
                    .replace(/Pesquisa customizada/, this.localize("PesquisaCustomizada"))
            )
        }
    }

    /**
     * Pesquisa satusfação labels locale
     * */
    public parsePesquisaLocaleRevert = (pesquisa: any) => {
        if (pesquisa == this.localize("Nenhuma"))
            return "Nenhuma";
        else if (this.localize("Classificacao"))
            return "Classificação de atendimento";
        else if (this.localize("PesquisaExterna"))
            return "Pesquisa externa";
        else if (this.localize("PesquisaCustomizada"))
            return "Pesquisa customizada";
    }

    /**
     * Setup App
     * */
    private setupApp = async () => {
        let responseSetup = await getAppSetup();

        if (responseSetup) {
            this.setState({
                setup: responseSetup.data
            })
        }
    }

    /**
     * Get App Configs
     * */
    private async getAppConfig() {
        let response = await getAppConfig();

        if (response.status === 200 && response.data) {
            var itensPesquisaSatisfacao = PesquisaSatisfacaoConstants.pesquisaSatisfacao;

            if (response.data.ratingQuestions) {
                itensPesquisaSatisfacao.push(PesquisaSatisfacaoConstants.pesquisaCustomizada);
            }

            this.setState({
                appConfig: response.data,
                itemsPesquisaSatisfacao: this.parsePesquisaLocale(itensPesquisaSatisfacao),
            });
        }
    };

    /**
     * Get Version
     * */
    private async getVersion() {
        let response = await getVersion();

        if (response.status === 200 && response.data) {
            this.setState({
                version: response.data
            })
        }
    }

    /**
     * Get App Catalog Manifest Id
     * */
    private async getAppCatalogId() {
        let response = await getAppCatalogId(this.appManifestId);

        if (response.status === 200 && response.data) {
            this.setState({
                appCatalogId: response.data
            })
        }
    }

    /**
     * Get Admins
     * */
    private async getAdmins() {
        let response = await getAdmins();

        if (response.status === 200 && response.data) {
            this.setState({
                admins: response.data.split(/,|;/g),
            })
        }
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }

    private isSaveBtnDisabled = () => {
        return !(this.state.isValidUrlAjudaComoFunciona &&
            this.state.isValidUrlAjudaPerguntasFrequentes &&
            this.state.isValidHorarioInicial &&
            this.state.isValidHorarioFinal &&
            this.state.isValidHorario &&
            this.state.isValidUrlPesquisaExterna)
    }

    private onSave = () => {
        let diasAtendimento = "";
        this.state.diasAtendimento?.forEach((item: any) => {
            if (diasAtendimento) {
                diasAtendimento += ", " + item.key;
            }
            else {
                diasAtendimento = item.key;
            }
        })

        let configData = {
            gestores: this.state.selectedGestoresId,
            atendentes: this.state.selectedAtendentesId,
            horarioAtendimentoInicial: this.state.horarioAtendimentoInicial,
            horarioAtendimentoFinal: this.state.horarioAtendimentoFinal,
            horarioAtendimentoDias: diasAtendimento,
            ajudaComoFunciona: this.state.ajudaComoFunciona,
            ajudaPerguntasFrequentes: this.state.ajudaPerguntasFrequentes,
            pesquisaSatisfacao: this.parsePesquisaLocaleRevert(this.state.pesquisaSatisfacao),
            urlPesquisaSatisfacaoExterna: this.state.urlPesquisaSatisfacaoExterna,
            tiposCategorias: this.state.listTiposCategorias,
            language: this.parseLocale(this.state.language),
            autoRecordingGovernance: this.state.recording,
            sharePointSiteUrl: this.state.sharePointSiteUrl,
            userQueueAttachments: this.state.userQueueAttachments,
            welcomeText: this.state.welcomeText,
        }

        setAppSettings(configData).then(() => {
            dialog.url.submit(this.parseLocale(this.state.language));
        });

    }

    private onCancel() {
        dialog.url.submit();
    }

    private getGroupData = async () => {
        try {
            const response = await getUserGroups();
            const responseSettingsGroups = await getGroups();

            if (response.data && responseSettingsGroups.data) {
                this.setState({
                    groups: _.uniqBy(response.data.concat(responseSettingsGroups.data), 'id'),
                });
            }
        }
        catch (error) {
            return error;
        }
    }

    private getGroupItems() {
        if (this.state.groups) {
            return this.makeDropdownItems(this.state.groups);
        }
        const dropdownItems: dropdownItem[] = [];
        return dropdownItems;
    }

    private onGroupSearch = (itemList: any, searchQuery: string) => {
        const result = itemList.filter(
            (item: { header: string; content: string; }) => (item.header && item.header.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1) ||
                (item.content && item.content.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1),
        )
        return result;
    }

    private onGroupSearchQueryChange = async (event: any, itemsData: any) => {
        if (!itemsData.searchQuery) {
            this.setState({
                noResultMessage: "",
            });
        }
        else if (itemsData.searchQuery && itemsData.searchQuery.length <= 2) {
            this.setState({
                loading: false,
                noResultMessage: this.localize("NenhumaOcorrencia"),
            });
        }
        else if (itemsData.searchQuery && itemsData.searchQuery.length > 2) {
            // handle event trigger on item select.
            const result = itemsData.items && itemsData.items.find(
                (item: { header: string; }) => item.header.toLowerCase() === itemsData.searchQuery.toLowerCase()
            )
            if (result) {
                return;
            }

            this.setState({
                loading: true,
                noResultMessage: "",
            });

            try {
                const query = encodeURIComponent(itemsData.searchQuery);
                const response = await searchGroups(query);
                this.setState({
                    groups: response.data,
                    loading: false,
                    noResultMessage: this.localize("NenhumaOcorrencia"),
                });
            }
            catch (error) {
                return error;
            }
        }

        if (itemsData.searchQuery.length == 0) {
            const response = await getUserGroups();

            this.setState({
                groups: response.data,
                loading: false,
            });
        }
    }

    private onGestoresChange = (event: any, itemsData: any) => {
        if (itemsData.value.length > 1)
            this.setState({
                selectedGestores: itemsData.value[1],
                selectedGestoresId: itemsData.value[1].key,
            })
        else
            this.setState({
                selectedGestores: itemsData.value[0],
                selectedGestoresId: itemsData?.value.length ? itemsData.value[0].key : "",
            })
    }

    private onAtendentesChange = (event: any, itemsData: any) => {
        if (itemsData.value.length > 1)
            this.setState({
                selectedAtendentes: itemsData.value[1],
                selectedAtendentesId: itemsData.value[1].key,
            })
        else
            this.setState({
                selectedAtendentes: itemsData.value[0],
                selectedAtendentesId: itemsData?.value.length ? itemsData.value[0].key : "",
            })
    }

    private onTipoCategoriaChange = (event: any) => {
        this.setState({
            tipoCategoria: event.target.value,
        });
    }

    private onHorarioInicialChange = (event: any, itemData: any) => {
        var isValidHorario = true;
        var isValidHorarioInicial = true;
        if (itemData.value && this.state.horarioAtendimentoFinal) {
            var horarioInicial = itemData.value.replace(":", "");
            var horarioFinal = this.state.horarioAtendimentoFinal.replace(":", "");

            if (Number(horarioInicial) >= Number(horarioFinal)) {
                isValidHorarioInicial = false;
            }
            else {
                isValidHorarioInicial = true;
                this.setState({ isValidHorarioFinal: true });
            }
        }
        else if (itemData.value) {
            isValidHorario = false;
        }

        this.setState({
            horarioAtendimentoInicial: itemData.value == null ? "" : itemData.value,
            isValidHorarioInicial: isValidHorarioInicial,
            isValidHorario: isValidHorario
        })
    }

    private onHorarioFinalChange = (event: any, itemData: any) => {
        var isValidHorario = true;
        var isValidHorarioFinal = true;
        if (itemData.value && this.state.horarioAtendimentoInicial) {
            var horarioFinal = itemData.value.replace(":", "");
            var horarioInicial = this.state.horarioAtendimentoInicial.replace(":", "");

            if (Number(horarioInicial) >= Number(horarioFinal)) {
                isValidHorarioFinal = false;
            }
            else {
                isValidHorarioFinal = true;
                this.setState({ isValidHorarioInicial: true });
            }
        }
        else if (itemData.value) {
            isValidHorario = false;
        }

        this.setState({
            horarioAtendimentoFinal: itemData.value == null ? "" : itemData.value,
            isValidHorarioFinal: isValidHorarioFinal,
            isValidHorario: isValidHorario
        })
    }

    private onDiasAtendimentoChange = (event: any, itemsData: any) => {

        this.setState({
            diasAtendimento: itemsData.value
        })
    }

    private onAjudaComoFuncionaChange = (event: any, itemsData: any) => {

        var isValidUrlAjudaComoFunciona = true;
        if (itemsData.value) {
            isValidUrlAjudaComoFunciona = CommonHelper.validUrl(itemsData.value);
        }
        else {
            isValidUrlAjudaComoFunciona = true;
        }

        this.setState({
            ajudaComoFunciona: itemsData.value,
            isValidUrlAjudaComoFunciona: isValidUrlAjudaComoFunciona,
        })
    }

    private onAjudaPerguntasFrequentesChange = (event: any, itemsData: any) => {

        var isValidUrlPerguntasFrequentes = true;
        if (itemsData.value) {
            isValidUrlPerguntasFrequentes = CommonHelper.validUrl(itemsData.value);
        }
        else {
            isValidUrlPerguntasFrequentes = true;
        }

        this.setState({
            ajudaPerguntasFrequentes: itemsData.value,
            isValidUrlAjudaPerguntasFrequentes: isValidUrlPerguntasFrequentes,
        })
    }

    private onWelcomeTextChange = (event: any, itemsData: any) => {
        this.setState({
            welcomeText: itemsData.value,
        })
    }

    private onPesquisaSatisfacaoChange = (event: any, itemsData: any) => {
        this.setState({
            pesquisaSatisfacao: itemsData.value,
            urlPesquisaSatisfacaoExterna: "",
            isValidUrlPesquisaExterna: itemsData.value == this.getPesquisaLocale(PesquisaSatisfacaoConstants.pesquisaExterna) ? false : true,
        })
    }

    private onUrlPesquisaSatisfacaoExternaChange = (event: any, itemsData: any) => {
        var isValidUrlPesquisaExterna = false;
        if (itemsData.value) {
            isValidUrlPesquisaExterna = CommonHelper.validUrl(itemsData.value);
        }
        else {
            isValidUrlPesquisaExterna = false;
        }

        this.setState({
            urlPesquisaSatisfacaoExterna: itemsData.value,
            isValidUrlPesquisaExterna: isValidUrlPesquisaExterna
        })
    }

    private onLanguageChange = (event: any, itemsData: any) => {
        this.setState({
            language: itemsData.searchQuery,
            flagImage: itemsData.value.image,
        })
    }

    private toggleRecording = (event: any, data: any) => {
        this.setState({
            recording: data.checked,
        });
    }

    private toggleUserQueueAttachments = (event: any, data: any) => {
        this.setState({
            userQueueAttachments: data.checked,
        });
    }

    private onSharePointSiteUrlChange = (event: any, itemsData: any) => {
        var isValidSharePointSiteUrl = true;
        if (itemsData.value) {
            isValidSharePointSiteUrl = CommonHelper.validUrl(itemsData.value);
        }
        else {
            isValidSharePointSiteUrl = true;
        }

        this.setState({
            sharePointSiteUrl: itemsData.value,
            isValidSharePointSiteUrl: isValidSharePointSiteUrl,
        })
    }

    private parseLocale = (lang: string) => {
        if (lang == this.localize("Portugues"))
            return "pt-BR";
        else if (lang == this.localize("Ingles"))
            return "en-US";
        else if (lang == this.localize("Espanhol"))
            return "es-ES";
    }

    private parseLang = (locale: string) => {
        if (locale == "pt-BR")
            return this.localize("Portugues")
        else if (locale == "en-US")
            return this.localize("Ingles")
        else if (locale == "es-ES")
            return this.localize("Espanhol")
    }

    private addTipoCategoria = (tipoCategoria: any) => {
        let tiposCategorias = this.state.listTiposCategorias || [];
        tiposCategorias.push(tipoCategoria);

        this.setState({
            listTiposCategorias: tiposCategorias,
            tipoCategoria: "",
        });
    }

    private deleteTipoCategoria = (tipoCategoria: any, index: number) => {
        var indexTipoCategoria = this.state.listTiposCategorias.indexOf(tipoCategoria);

        if (indexTipoCategoria > -1) {
            this.state.listTiposCategorias.splice(indexTipoCategoria, 1)
        }

        this.setState({
            listTiposCategorias: this.state.listTiposCategorias
        })
    }

    private renderTiposCategorias = (item: any, index: number) => {
        return {
            key: index,
            className: 'item-tipo-categoria',
            header: item,
            truncateHeader: true,
            endMedia: (
                <CloseIcon circular size="small" styles={{ cursor: 'pointer' }} onClick={() => this.deleteTipoCategoria(item, index)} />
            )
        }
    }

    private makeDropdownItems = (items: any[] | undefined) => {
        const resultedTeams: dropdownItem[] = [];
        if (items) {
            items.forEach((element) => {
                if (element) {
                    resultedTeams.push({
                        key: element.id,
                        header: element.displayName,
                        content: element.mail,
                        image: ImageUtil.makeInitialImage(element.displayName),
                        team: {
                            id: element.id
                        },

                    });
                }
            });
        }

        return resultedTeams;
    }

    private setActiveTabId = (index: number, item: any) => {
        this.setState({
            selectedMenu: index
        })
    }

    public render() {
        if (!this.state.loader) {
            return (
                <div className="config-task">
                    <div className="formContainer">
                        <Flex gap="gap.medium" padding="padding.medium">
                            <Flex.Item size="medium">
                                <Flex className="settings-menu" gap="gap.small" column>
                                    <Menu
                                        activeIndex={this.state.selectedMenu}
                                        onItemClick={(currentTarget, props) =>
                                            this.setActiveTabId(props && props.index ? props.index : 0, props)
                                        }
                                        items={[
                                            {
                                                icon: (<HeadsetIcon outline />),
                                                key: 'geral',
                                                content: this.localize("Geral"),
                                            },
                                            {
                                                icon: (<ShieldKeyholeIcon outline />),
                                                key: 'acesso',
                                                content: this.localize("ControleAcesso"),
                                            },
                                            {
                                                icon: (<CalendarIcon outline />),
                                                key: 'horario',
                                                content: this.localize("HorarioComercial"),
                                            },
                                            {
                                                icon: (<BuildingIcon outline />),
                                                key: 'categorias',
                                                content: this.localize("Categorias"),
                                            },
                                            {
                                                icon: (<TranslationIcon outline />),
                                                key: 'lang',
                                                content: this.localize("Idioma")
                                            },
                                            {
                                                icon: (<InfoIcon outline />),
                                                key: 'about',
                                                content: this.localize("Sobre")
                                            }
                                        ]}
                                        vertical
                                    />
                                </Flex>
                            </Flex.Item>
                            <Flex.Item grow>
                                <div className="formContentContainer permissions">
                                    {this.state.selectedMenu == 0 &&
                                        <Flex column aria-disabled={!this.state.setup}>
                                            <Input
                                                className="inputField"
                                                fluid
                                                value={this.state.ajudaComoFunciona}
                                                label={this.localize("AjudaComoFunciona")}
                                                onChange={this.onAjudaComoFuncionaChange}
                                                error={this.state.ajudaComoFunciona != '' && !this.state.isValidUrlAjudaComoFunciona}
                                                errorIndicator={<Tooltip content={this.localize("URLInvalida")}><ExclamationCircleIcon /></Tooltip>}
                                                disabled={!this.state.setup}
                                            />

                                            <Input
                                                className="inputField"
                                                fluid
                                                value={this.state.ajudaPerguntasFrequentes}
                                                label={this.localize("AjudaPerguntas")}
                                                onChange={this.onAjudaPerguntasFrequentesChange}
                                                error={this.state.ajudaPerguntasFrequentes != '' && !this.state.isValidUrlAjudaPerguntasFrequentes}
                                                errorIndicator={<Tooltip content={this.localize("URLInvalida")}><ExclamationCircleIcon /></Tooltip>}
                                                disabled={!this.state.setup}
                                            />

                                            <div className="inputField">
                                                <Text className="label-field" content={"Mensagem de boas vindas"} />

                                                <TextArea
                                                    variables={{
                                                        height: "120px"
                                                    }}
                                                    fluid
                                                    value={this.state.welcomeText}
                                                    onChange={this.onWelcomeTextChange}
                                                />
                                            </div>

                                            <div className="inputField">
                                                <Text className="label-field" content={this.localize("PesquisaSatisfacao")} />
                                                <Dropdown
                                                    fluid
                                                    clearable
                                                    checkable
                                                    items={this.state.itemsPesquisaSatisfacao}
                                                    placeholder={this.localize("TipoPesquisaSatisfacao")}
                                                    onChange={this.onPesquisaSatisfacaoChange}
                                                    value={this.state.pesquisaSatisfacao}
                                                    disabled={!this.state.setup}
                                                />
                                            </div>

                                            <div className="inputField" hidden={!(this.state.pesquisaSatisfacao == this.getPesquisaLocale(PesquisaSatisfacaoConstants.pesquisaExterna))} >
                                                <Text className="label-field" content={this.localize("URLPesquisaSatisfacao")} />
                                                <Input
                                                    fluid
                                                    value={this.state.urlPesquisaSatisfacaoExterna}
                                                    onChange={this.onUrlPesquisaSatisfacaoExternaChange}
                                                    error={this.state.urlPesquisaSatisfacaoExterna != '' && !this.state.isValidUrlPesquisaExterna}
                                                    errorIndicator={<Tooltip content={this.localize("URLInvalida")}><ExclamationCircleIcon /></Tooltip>}
                                                    disabled={!this.state.setup}
                                                />
                                            </div>

                                            {this.state.features?.includes(Features.RecordingGovernance) &&
                                                <div className="inputField">
                                                    <Flex gap="gap.medium" vAlign="center">
                                                        <Text className="label-field" content={this.localize("GovernancaGravacoes")} />
                                                        <Tooltip
                                                            trigger={<Icon className="info-icon" iconName="Info" />}
                                                            content={
                                                                <Text content={this.localize("GovernancaGravacoesInfo")} />
                                                            }
                                                            position="after"
                                                            align="center"
                                                        />
                                                    </Flex>

                                                    <Checkbox
                                                        checked={this.state.recording}
                                                        onChange={this.toggleRecording}
                                                        toggle
                                                    />

                                                    <Flex hidden={!this.state.recording} gap="gap.medium" vAlign="center">
                                                        <Text className="label-field" content={this.localize("UrlSharepoint")} />
                                                        <Tooltip
                                                            trigger={<Icon className="info-icon" iconName="Info" />}
                                                            content={
                                                                <Text content={this.localize("UrlSharepointInfo")} />
                                                            }
                                                            position="after"
                                                            align="center"
                                                        />
                                                    </Flex>

                                                    <Input
                                                        fluid
                                                        value={this.state.sharePointSiteUrl}
                                                        onChange={this.onSharePointSiteUrlChange}
                                                        error={this.state.sharePointSiteUrl != '' && !this.state.isValidSharePointSiteUrl}
                                                        errorIndicator={<Tooltip content={this.localize("URLInvalida")}><ExclamationCircleIcon /></Tooltip>}
                                                        disabled={!this.state.setup}
                                                        hidden={!this.state.recording}
                                                    />
                                                </div>
                                            }

                                            {this.state.features?.includes(Features.UserQueueAttachments) &&
                                                <div className="inputField">
                                                    <Flex gap="gap.medium" vAlign="center">
                                                        <Text className="label-field" content={this.localize("AnexosUsuario")} />
                                                        <Tooltip
                                                            trigger={<Icon className="info-icon" iconName="Info" />}
                                                            content={
                                                                <Text content={this.localize("AnexosUsuarioInfo")} />
                                                            }
                                                            position="after"
                                                            align="center"
                                                        />
                                                    </Flex>

                                                    <Checkbox
                                                        checked={this.state.userQueueAttachments}
                                                        onChange={this.toggleUserQueueAttachments}
                                                        toggle
                                                    />
                                                </div>
                                            }
                                        </Flex>
                                    }

                                    {this.state.selectedMenu == 1 &&
                                        <React.Fragment>
                                            <div className="inputField admin">
                                                <Flex gap="gap.medium" vAlign="center">
                                                    <Text className="label-field" content={this.localize("Admins")} />
                                                    <Tooltip
                                                        trigger={<Icon className="info-icon" iconName="Info" />}
                                                        content={
                                                            <Flex gap="gap.small" column>
                                                                <Text content={this.localize("InfoAdmin")} />
                                                                <Text content={this.localize("InfoAdminLeitura")} />
                                                            </Flex>
                                                        }
                                                        position="after"
                                                        align="center"
                                                    />
                                                </Flex>

                                                <Dropdown
                                                    multiple
                                                    fluid
                                                    disabled
                                                    className="hideToggle"
                                                    checkable={false}
                                                    clearable={false}
                                                    value={this.state.admins}
                                                    unstable_pinned={true}
                                                />
                                            </div>

                                            <div className="inputField">
                                                <Flex gap="gap.medium" vAlign="center">
                                                    <Text className="label-field" content={this.localize("Gestores")} />
                                                    <Tooltip
                                                        trigger={<Icon className="info-icon" iconName="Info" />}
                                                        content={
                                                            <Text content={this.localize("InfoGestores")} />
                                                        }
                                                        position="after"
                                                        align="center"
                                                    />
                                                </Flex>

                                                <Dropdown
                                                    multiple
                                                    fluid
                                                    className="hideToggle"
                                                    placeholder={this.localize("GrupoM365")}
                                                    search={this.onGroupSearch}
                                                    loading={this.state.loading}
                                                    loadingMessage={this.localize("Carregando")}
                                                    items={this.getGroupItems()}
                                                    value={this.state.selectedGestores}
                                                    onSearchQueryChange={this.onGroupSearchQueryChange}
                                                    onChange={this.onGestoresChange}
                                                    noResultsMessage={this.state.noResultMessage}
                                                    unstable_pinned={true}
                                                    renderSelectedItem={(SelectedItemComponent, props) => {
                                                        return (
                                                            <Tooltip content={props.header} position="below" align="center">
                                                                <SelectedItemComponent {...props} />
                                                            </Tooltip>
                                                        );
                                                    }}
                                                />
                                            </div>

                                            <div className="inputField" >
                                                <Flex gap="gap.medium" vAlign="center">
                                                    <Text className="label-field" content={this.localize("Atendentes")} />
                                                    <Tooltip
                                                        trigger={<Icon className="info-icon" iconName="Info" />}
                                                        content={
                                                            <Text content={this.localize("InfoAtendentes")} />
                                                        }
                                                        position="after"
                                                        align="center"
                                                    />
                                                </Flex>

                                                <Dropdown
                                                    multiple
                                                    fluid
                                                    className="hideToggle"
                                                    placeholder={this.localize("GrupoM365")}
                                                    search={this.onGroupSearch}
                                                    loading={this.state.loading}
                                                    loadingMessage={this.localize("Carregando")}
                                                    items={this.getGroupItems()}
                                                    value={this.state.selectedAtendentes}
                                                    onSearchQueryChange={this.onGroupSearchQueryChange}
                                                    onChange={this.onAtendentesChange}
                                                    noResultsMessage={this.state.noResultMessage}
                                                    unstable_pinned={true}
                                                    renderSelectedItem={(SelectedItemComponent, props) => {
                                                        return (
                                                            <Tooltip content={props.header} position="below" align="center">
                                                                <SelectedItemComponent {...props} />
                                                            </Tooltip>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </React.Fragment>
                                    }

                                    {this.state.selectedMenu == 2 &&
                                        <Flex column aria-disabled={!this.state.setup}>
                                            <div className="inputField diasAtendimento" >
                                                <Flex gap="gap.medium" vAlign="center">
                                                    <Text className="label-field" content={this.localize("DiasAtendimento")} />
                                                    <Tooltip
                                                        trigger={<Icon className="info-icon" iconName="Info" />}
                                                        content={
                                                            <Flex gap="gap.small" column>
                                                                <Text content={this.localize("InfoDias")} />
                                                                <Text content={this.localize("InfoDiasParam")} />
                                                            </Flex>
                                                        }
                                                        position="after"
                                                        align="center"
                                                    />
                                                </Flex>

                                                <Dropdown
                                                    multiple
                                                    fluid
                                                    clearable
                                                    checkable
                                                    items={this.getDaysOfWeek()}
                                                    placeholder={this.localize("SelecioneDiasAtendimento")}
                                                    onChange={this.onDiasAtendimentoChange}
                                                    value={this.state.diasAtendimento}
                                                    disabled={!this.state.setup}
                                                />
                                            </div>

                                            <Flex space="between">
                                                <FlexItem size="size.quarter">
                                                    <div className="inputField hours">
                                                        <Flex gap="gap.medium" vAlign="center">
                                                            <Text className="label-field" content={this.localize("HorariosAtendimento")} />
                                                            <Tooltip
                                                                trigger={<Icon className="info-icon" iconName="Info" />}
                                                                content={
                                                                    <Flex gap="gap.small" column>
                                                                        <Text content={this.localize("InfoHorario")} />
                                                                        <Text content={this.localize("InfoHorarioParam")} />
                                                                    </Flex>
                                                                }
                                                                position="after"
                                                                align="center"
                                                            />
                                                        </Flex>

                                                        <Dropdown
                                                            items={Constants.hoursStart}
                                                            fluid
                                                            clearable
                                                            checkable
                                                            placeholder={this.localize("HorarioInicial")}
                                                            onChange={this.onHorarioInicialChange}
                                                            value={this.state.horarioAtendimentoInicial}
                                                            error={this.state.horarioAtendimentoInicial != '' && !this.state.isValidHorarioInicial}
                                                            disabled={!this.state.setup}
                                                        />
                                                    </div>
                                                </FlexItem>

                                                <FlexItem size="size.quarter">
                                                    <div className="inputField hours" >
                                                        <Text className="label-field" styles={{ height: "18px" }} />
                                                        <Dropdown
                                                            items={Constants.hoursEnd}
                                                            fluid
                                                            clearable
                                                            checkable
                                                            placeholder={this.localize("HorarioFinal")}
                                                            onChange={this.onHorarioFinalChange}
                                                            value={this.state.horarioAtendimentoFinal}
                                                            error={this.state.horarioAtendimentoFinal != '' && !this.state.isValidHorarioFinal}
                                                            disabled={!this.state.setup}
                                                        />
                                                    </div>
                                                </FlexItem>
                                            </Flex>
                                        </Flex>
                                    }

                                    {this.state.selectedMenu == 3 &&
                                        <Flex column aria-disabled={!this.state.setup}>
                                            <Input
                                                className="inputField"
                                                icon={this.state.tipoCategoria ? <AddIcon styles={{ cursor: "pointer" }} onClick={() => this.addTipoCategoria(this.state.tipoCategoria)} /> : <React.Fragment />}
                                                fluid
                                                value={this.state.tipoCategoria}
                                                label={this.localize("Itens")}
                                                onChange={this.onTipoCategoriaChange}
                                                disabled={!this.state.setup}
                                            />

                                            <div className="inputField" >
                                                <List
                                                    items={this.state.listTiposCategorias ? this.state.listTiposCategorias.map(this.renderTiposCategorias.bind(this)) : []}
                                                />
                                            </div>
                                        </Flex>
                                    }

                                    {this.state.selectedMenu == 4 &&
                                        <Flex column aria-disabled={!this.state.setup}>
                                            <div className="inputField" >
                                                <Text className="label-field" content={this.localize("Idioma")} />

                                                <Flex className="language">
                                                    <img className="flag-selector" height="32" src={this.state.flagImage} />

                                                    <Dropdown
                                                        items={[
                                                            {
                                                                key: "pt-BR",
                                                                header: this.localize("Portugues"),
                                                                image: this.flagPT,
                                                            },
                                                            {
                                                                key: "en-US",
                                                                header: this.localize("Ingles"),
                                                                image: this.flagEN,
                                                            },
                                                            {
                                                                key: "es-ES",
                                                                header: this.localize("Espanhol"),
                                                                image: this.flagES,
                                                            },
                                                        ]}
                                                        placeholder={this.localize("SelecioneIdioma")}
                                                        checkable
                                                        onChange={this.onLanguageChange}
                                                        value={this.parseLang(this.state.language)}
                                                        disabled={!this.state.setup}
                                                    />
                                                </Flex>
                                            </div>
                                        </Flex>
                                    }

                                    {this.state.selectedMenu == 5 &&
                                        <Flex gap="gap.medium" column>
                                            <div className="inputField">
                                                <Flex gap="gap.medium" column>
                                                    <Flex gap="gap.medium" vAlign="start">
                                                        <Image className="logo-img" circular src={ImagesBase64.logo} />

                                                        <Flex gap="gap.small" column>
                                                            <Text size="large" weight="bold" content={this.localize("BalcaoVirtual")} />

                                                            <Flex gap="gap.smaller" column>
                                                                <Text content={this.localize("DesenvolvidoPor")} />
                                                                <Text temporary content={`Build: ${this.state.version}`} />

                                                                <Text temporary content={"Id do catálogo:"} />
                                                                <Text temporary content={this.state.appCatalogId} />
                                                            </Flex>
                                                        </Flex>
                                                    </Flex>
                                                </Flex>
                                            </div>
                                        </Flex>
                                    }
                                </div>
                            </Flex.Item>
                        </Flex>
                    </div>

                    <div className="footerContainer">
                        <div className="buttonContainer">
                            <Button content={this.localize("Cancelar")} id="cancelBtn" onClick={this.onCancel} />
                            <Button content={this.localize("Salvar")} id="saveBtn" onClick={this.onSave.bind(this)} primary disabled={this.isSaveBtnDisabled()} />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (<LoaderConfigApp />)
        }
    }
}

const configAppWithTranslation = withTranslation()(Settings);
export default configAppWithTranslation;

